angular
  .module('contributor')

  .directive('contributorHeadquarterAddress', function() {
    return {
      restrict: 'E',
      require: '^ngModel',
      scope: {
        headquarter: '=ngModel'
      },
      templateUrl:
        'custom/contributor/views/partials/contributorHeadquarterAddress.html'
    };
  });
